import React from 'react';
import i18n from 'i18n';
import styles from './SubTitle.module.css';

const SubTitle = () => {
  return (
    <React.Fragment>
      <span>
        {i18n.t('transactionsDropzone:Dropzone.subtitle.title')}
        <i style={{ fontStyle: 'initial' }} className={'js-Transactions_heading_help ml-1 ' + styles.SubTitleLink}>
          {i18n.t('transactionsDropzone:Dropzone.subtitle.link')}
        </i>
      </span>
    </React.Fragment>
  );
};

export default SubTitle;
